<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title=" PTJ">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <!-- placeholder="Sila Masukan Kod" -->
                        <w-input v-model="cari.kod" label="Kod" />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.kod_jabatan"
                            label="Kod Jabatan"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input v-model="cari.kod_ptj" label="Kod PTJ" />
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.kod_pp"
                            label="Kod Penyata pemungut"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.keterangan"
                            label="Jabatan/PTJ"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <z-lookup
                            label="Daerah"
                            :url="service_utiliti + 'lookup/daerah'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_daerah_id"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <z-lookup
                            label="Status"
                            :options="status"
                            v-model="cari.status"
                            :sort="false"
                            :cache="false"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <z-lookup
                            label="Bank"
                            :url="service_utiliti + 'lookup/tambah_bank'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.bank_id"
                        />
                        <!-- <z-lookup label="Status" name="status"
                        :options="[{label: 'AKTIF', value: 1}, {label: 'TIDAK AKTIF', value: 3}]" :sort="false" :cache="false" v-model="cari.status" /> -->
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <w-dialog
                v-model="modal.show"
                :fullscreen="modal.fullscreen"
                :width="modal.width"
                :persistent="modal.persistent"
                :persistent-no-animation="modal.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title> Paparan Jejak Audit </template>
                <z-jejak-audit :jejak_audit="form.jejak_audit" />
                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="modal.show = false"
                        >Tutup</w-button
                    >
                </template>
            </w-dialog>

            <w-dialog
                v-model="dialog.show"
                :fullscreen="dialog.fullscreen"
                :width="dialog.width"
                :persistent="dialog.persistent"
                :persistent-no-animation="dialog.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <template v-if="form.kod">
                        Kemas Kini Jabatan / PTJ
                    </template>
                    <template v-else> Tambah Jabatan / PTJ </template>
                </template>
                <template #default>
                    <w-form
                        ref="form"
                        v-model="dialog.valid"
                        @validate="submit"
                        @success="success"
                    >
                        <template v-if="form.jabatan && form.jabatan.kod"
                            ><br />

                            <tr>
                                <th>
                                    Jabatan/PTG Utama
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :
                                </th>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <td>{{ form.jabatan.kod }} |</td>
                                <td>{{ form.jabatan.kod_ptj }} |</td>
                                <td>{{ form.jabatan.keterangan }}</td>
                            </tr>
                            <br /><br />
                        </template>

                        <w-flex justify-space-between class="mb4">
                            <div class="xs6">
                                <z-input
                                    label="Kod *"
                                    name="kod"
                                    v-model="form.kod"
                                    :validators="[validators.required]"
                                />
                            </div>
                            <div class="xs6">
                                <z-input
                                    label="Kod Jabatan *"
                                    name="kod_jabatan"
                                    v-model="form.kod_jabatan"
                                    :validators="[validators.required]"
                                    maxlength="6"
                                />
                            </div>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <div class="xs6">
                                <z-input
                                    label="Kod PTJ *"
                                    name="kod_ptj"
                                    v-model="form.kod_ptj"
                                    :validators="[validators.required]"
                                    maxlength="8"
                                />
                            </div>
                            <div class="xs6">
                                <z-input
                                    label="Kod Penyata Pemungut *"
                                    name="kod_pp"
                                    v-model="form.kod_pp"
                                    :validators="[validators.required]"
                                />
                            </div>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input
                                label="Jabatan/PTJ *"
                                name="keterangan"
                                v-model="form.keterangan"
                                :validators="[validators.required]"
                            />
                        </w-flex>

                        <w-flex justify-space-between class="mb4">
                            <z-input
                                label="Alamat *"
                                name="alamat1"
                                v-model="form.alamat1"
                                :validators="[validators.required]"
                            />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input
                                label="No. Telefon"
                                v-model="form.no_tel"
                                name="no_tel"
                                type="tel"
                                :validators="[
                                    validators.numeric,
                                    validators.required,
                                ]"
                            />
                            <z-input
                                label="Email *"
                                name="Email"
                                v-model="form.emel"
                                :validators="[
                                    validators.required,
                                    validators.email,
                                ]"
                            />
                        </w-flex>
                        <z-lookup
                            label="Poskod"
                            name="lkp_poskod_id"
                            :url="service_utiliti + 'lookup/lkp_poskod'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_poskod_id"
                        /><br />
                        <w-flex justify-center align-center v-if="form.bandar">
                            <div class="xs6">
                                <h5 class="fw-semibold m0">Bandar :</h5>
                                {{ form.bandar }}
                            </div>

                            <div class="xs6">
                                <h5 class="fw-semibold m0">Negeri :</h5>
                                {{ form.negeri }}
                            </div>
                        </w-flex>
                        <!-- <w-flex justify-space-between class="mb4">
                            <z-input
                              label="Email"
                              name="Email"
                              v-model="form.emel"
                              :validators="[validators.required]"/>
                        </w-flex> -->
                        <z-lookup
                            label="Bank*"
                            name="bank"
                            :url="service_utiliti + 'lookup/tambah_bank'"
                            :sort="false"
                            :cache="false"
                            v-model="form.bank_id"
                            
                        /><br />
                        <w-flex>
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td>Daerah</td>
                                        <td>
                                            <w-icon class="mr1" @click="addItem"
                                                >fal fa-plus</w-icon
                                            >
                                        </td>
                                    </tr>
                                </thead>
                                <tr v-for="(dt, index) in form.jabatan_daerah">
                                    <td>
                                        <z-lookup
                                            label="Pilih Daerah.."
                                            name="lkp_daerah_id"
                                            :url="
                                                service_utiliti +
                                                'lookup/daerah'
                                            "
                                            :sort="false"
                                            :cache="false"
                                            v-model="dt.lkp_daerah_id"
                                        >
                                        </z-lookup>
                                    </td>
                                    <td>
                                        <w-icon
                                            class="mr1"
                                            @click="removeItem(index)"
                                            >fal fa-trash</w-icon
                                        >
                                    </td>
                                </tr>
                            </table>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <label>Status</label>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <w-switch
                                class="mr6"
                                v-model="form.status"
                            ></w-switch>
                        </w-flex>
                    </w-form>
                </template>
                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialog.show = false"
                        >Tutup</w-button
                    >
                    <w-button
                        class="ml1"
                        :loading="dialog.loading"
                        :disabled="dialog.valid === false"
                        @click="$refs.form.validate()"
                        >{{ form.saveButton }}</w-button
                    >
                </template>
            </w-dialog>

            <z-table
                ref="tbluser"
                title="Senarai PTJ"
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
                <template #button>
                    <template v-if="$zutil.can('Ptj Penyediaan')">
                        <w-button
                            dark
                            class="indigo-dark2--bg ml1"
                            @click="add()"
                        >
                            <w-icon class="mr1">fal fa-plus</w-icon> Tambah
                        </w-button>
                    </template>
                </template>
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                <template
                    #item-cell.keterangan="{ item, label, header, index }"
                >
                    <template v-if="item.level >= 2"
                        >&nbsp;&nbsp;&nbsp;</template
                    >
                    <template v-if="item.level >= 3"
                        >&nbsp;&nbsp;&nbsp;</template
                    >
                    <template v-if="item.level >= 4"
                        >&nbsp;&nbsp;&nbsp;</template
                    >
                    <template v-if="item.level >= 5"
                        >&nbsp;&nbsp;&nbsp;</template
                    >
                    <template v-if="item.level >= 6"
                        >&nbsp;&nbsp;&nbsp;</template
                    >
                    <template v-if="item.level >= 7"
                        >&nbsp;&nbsp;&nbsp;</template
                    >
                    <template v-if="item.level >= 8"
                        >&nbsp;&nbsp;&nbsp;</template
                    >
                    <template v-if="item.level >= 9"
                        >&nbsp;&nbsp;&nbsp;</template
                    >
                    <template v-if="item.level >= 10"
                        >&nbsp;&nbsp;&nbsp;</template
                    >
                    {{ item.keterangan }}
                </template>
                <template #item-cell.daerah="{ item, label, header, index }">
                    <template v-for="(dt, index) in item.jabatan_daerah">
                        {{ dt.daerah_keterangan }}<br />
                    </template>
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <w-icon v-on="on" @click="edit(item)">
                                    fal fa-pencil </w-icon
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </template>
                            Kemaskini
                        </w-tooltip>
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <w-icon v-on="on" @click="add(item)">
                                    fal fa-plus </w-icon
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </template>
                            Tambah
                        </w-tooltip>
                        <template v-if="item.jabatans.length == 0">
                            <w-tooltip top>
                                <template #activator="{ on }">
                                    <w-icon v-on="on" @click="destroy(item)">
                                        fal fa-trash </w-icon
                                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </template>
                                Padam
                            </w-tooltip>
                        </template>
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <w-icon v-on="on" @click="show(item)">
                                    fal fa-eye </w-icon
                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </template>
                            Papar Jejak Audit
                        </w-tooltip>
                        <!-- <w-icon tile @click="edit(item)">fal fa-pencil</w-icon>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                             <w-icon class="mr1" @click="add(item)">fal fa-plus</w-icon>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
                        <!-- <template v-if="item.jabatans.length == 0"><w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon></template>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <w-icon tile @click="show(item)">fal fa-eye</w-icon> -->
                    </w-flex>
                </template>
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_utiliti + "ptj",
            reload: true,
            status: [
                {
                    value: 1,
                    label: "Aktif",
                },
                {
                    value: 2,
                    label: "Tidak Aktif",
                },
            ],
            form: {
                valid: null,
                submitted: false,
                sent: false,
                errorsCount: 0,
                no_tel: "",
            },
            validators: {
                required: (value) => !!value || "Medan Ini Wajib Isi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/\w+\.?\w+@\w+(\.\w+)+/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/ihasil" },
                { label: "Utiliti", route: "/utiliti" },
                { label: "PTJ ", route: "/utiliti/ptj" },
            ],
            cari: {
                kod: "",
                kod_jabatan: "",
                kod_ptj: "",
                kod_pp: "",
                keterangan: "",
                bank_id: "",
                lkp_bank_id: "",
                status: "",
                lkp_daerah_id: "",
            },
        };
    },
    methods: {
        add(jabatan) {
            // this.form = mapValues(this.form, () => null)
            this.form = {
                id: null,
                kod: null,
                kod_jabatan: null,
                jabatan: jabatan,
                kod_ptj: null,
                kod_pp: null,
                keterangan: null,
                status: null,
                no_tel: null,
                alamat1: null,
                emel: null,
                negeri: null,
                bandar: null,
                lkp_poskod_id: null,
                bank_id: null,
                jabatan_daerah: [{ lkp_daerah_id: null }],
            };
            this.dialog.show = true;
            // $('#' + this.resourceurl).modal('show')
            this.form.saveButton = "Simpan";
        },
        show(idx) {
            this.form = idx;
            this.modal.show = true;
        },

        addItem() {
            this.form.jabatan_daerah.push({ lkp_daerah_id: null });
        },

        removeItem(index) {
            this.form.jabatan_daerah.splice(index, 1);
        },

        search() {
            this.$inertia.visit(
                window.route("utiliti.ptj.index") +
                    "?kod=" +
                    this.cari.kod +
                    "&kod_jabatan=" +
                    this.cari.kod_jabatan +
                    "&kod_ptj=" +
                    this.cari.kod_ptj +
                    "&kod_pp=" +
                    this.cari.kod_pp +
                    "&keterangan=" +
                    this.cari.keterangan +
                    "&status=" +
                    this.cari.status +
                    "&lkp_daerah_id=" +
                    this.cari.lkp_daerah_id +
                    "&bank_id=" +
                    this.cari.bank_id,
                { preserveScroll: true }
            );
        },

        reset() {
            this.cari = {
                kod: "",
                kod_jabatan: "",
                kod_ptj: "",
                kod_pp: "",
                keterangan: "",
                status: "",
                lkp_daerah_id: "",
                bank_id: "",
            };
            this.search();
        },

        poskodDetail() {
            this.$zcomm
                .get(
                    this.service_utiliti +
                        "lookup/lkp_poskod_detail/" +
                        this.form.lkp_poskod_id
                )
                .then((res) => {
                    this.form.negeri = res.negeri;
                    this.form.lkp_negeri_id = res.lkp_negeri_id;
                    this.form.bandar = res.bandar;
                    this.form.lkp_jenis_alamat_id = 1;
                    this.form.jabatan_id = 1;
                });
        },
    },
    watch: {
        "form.lkp_poskod_id": function (q) {
            this.poskodDetail();
        },
    },
    mounted() {
        // override default setting
        // this.getData();
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.kod == "undefined") {
            this.cari.kod = "";
        }
        if (this.cari.kod_jabatan == "undefined") {
            this.cari.kod_jabatan = "";
        }
        if (this.cari.kod_ptj == "undefined") {
            this.cari.kod_ptj = "";
        }
        if (this.cari.kod_pp == "undefined") {
            this.cari.kod_pp = "";
        }
        if (this.cari.keterangan == "undefined") {
            this.cari.keterangan = "";
        }
        if (this.cari.status == "undefined") {
            this.cari.status = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
